import React from "react";

import {Button, Checkbox, Col, Descriptions, Menu, message, Row, Spin} from "antd";

import {TasksViewer} from "./TasksViewer";
import api from "../../api";
import {createScenarioLink, getProjectId} from "../../helpers";
import {ROP_MIN_LABEL} from "../../properties";
import {DataCard} from "../helpers/cards/Card";
import {Link, MaterialBlock} from "../helpers/cards/MaterialBlock";

export class WorkflowTodo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tasks: [],
			user: {},
			selectedTasks: [],
			loading: false,
			projectId: getProjectId(props.location),
		};
	}

	setLoading = value => {
		this.setState({loading: value});
	};

	getUserTasks = () => {
		this.setLoading(true);
		api.get(`/projects/${this.state.projectId}/tasks/user/${this.state.user["email"]}?active=True`)
			.then(json => {
				this.setState({tasks: json.data});
			})
			.finally(() => {
				this.setLoading(false);
			});
	};

	getUser = () => {
		api.get("/get_current_user").then(json => this.setState({user: json.data}));
	};

	componentDidMount() {
		this.getUser();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevState.user !== this.state.user) {
			this.getUserTasks();
		}
	}

	approveStep = task => {
		this.setLoading(true);
		message.info("Start approving the step");
		const data = {
			action: task.step_type,
			user: this.state.user["email"],
			position: task.position,
			status: "done",
		};
		this.doAction(data, task);
	};

	bulkApprove = () => {
		this.setLoading(true);
		const payload = [];
		for (const task of this.state.selectedTasks) {
			payload.push({
				task_id: task.task_id,
				step: task.step,
				workflow_id: task.workflow_id,
				object: task.object,
				object_type: task.object_type,
				email_cc: [],
				project_id: this.state.projectId,
				action: task.step_type,
				user: this.state.user["email"],
				position: task.position,
				status: "done",
			});
		}

		api.post(`/tasks/actions/bulk`, {tasks: payload})
			.then(json => {
				message.success(json.data);
				this.getUserTasks();
				this.setState({selectedTasks: []});
			})
			.catch(error => {
				this.getUserTasks();
			})
			.finally(() => {
				this.setLoading(false);
			});
	};

	rejectStep = task => {
		this.setLoading(true);
		message.info("Start rejecting the step");
		const data = {
			action: "reject",
		};
		this.doAction(data, task);
	};

	doAction = (data, task) => {
		const taskData = {
			task_id: task.task_id,
			step: task.step,
			workflow_id: task.workflow_id,
			object: task.object,
			object_type: task.object_type,
			email_cc: [],
			project_id: this.state.projectId,
			// comment: form.getFieldValue('comment')
		};

		api.post(`/tasks/actions`, {...taskData, ...data})
			.then(json => {
				message.success(json.data);
				this.getUserTasks();
			})
			.catch(error => {
				this.getUserTasks();
			})
			.finally(() => {
				this.setLoading(false);
			});
	};

	cancelStep = task => {
		this.setLoading(true);
		message.info("Start canceling the workflow");
		const data = {
			action: "cancel",
		};
		this.doAction(data, task);
	};

	onStepEnd = () => {
		message.info("Action completed successfully!");
		this.getUserTasks();
	};

	addTaskToSelectedList = task => {
		let selectedList = this.state.selectedTasks;
		if (selectedList.find(x => x.task_id === task.task_id)) {
			selectedList = selectedList.filter(x => x.task_id !== task.task_id);
		} else {
			if (selectedList.length > 50) {
				message.error("You've already selected 50 tasks");
			} else {
				selectedList.push(task);
			}
		}

		this.setState({selectedTasks: selectedList});
	};

	beautify(task) {
		if (task.object_type === "material") {
			return (
				<MaterialBlock material={task.object}>
					Step {task.step + 1}: {task.object}
				</MaterialBlock>
			);
		} else if (task.object_type === "bucket") {
			return (
				<Link
					className="beautiful-link"
					href={createScenarioLink(this.state.projectId, task.bucket_info.scenario_id, task.object)}>
					Bucket: {task.bucket_info.name}
				</Link>
			);
		}
	}

	getTitle = task => (
		<Row>
			<Col span={22}>{this.beautify(task)}</Col>

			<Col>
				{task.object_type === "material" && (
					<Checkbox
						style={{float: "right"}}
						checked={this.state.selectedTasks.find(x => x.task_id === task.task_id)}
						onClick={() => this.addTaskToSelectedList(task)}
					/>
				)}
			</Col>
		</Row>
	);

	render() {
		return (
			<>
				<Row>
					<Col span={18} style={{textAlign: "center", padding: 10}}>
						<DataCard>
							<h3>Your active tasks {this.state.tasks && <>({this.state.tasks.length})</>}</h3>
						</DataCard>
					</Col>
					<Col span={6} style={{textAlign: "center", padding: 10}}>
						<DataCard>
							<Button type={"primary"} onClick={this.bulkApprove}>
								<h3 style={{color: "white"}}>Bulk approve ({this.state.selectedTasks.length} / 50)</h3>
							</Button>
						</DataCard>
					</Col>
				</Row>

				<Spin spinning={this.state.loading}>
					<Row>
						{this.state.tasks.map((task, i) => {
							const menu = (
								<Menu>
									<Menu.Item onClick={() => this.approveStep(task)}>Approve</Menu.Item>
									{task.step === 0 && (
										<Menu.Item onClick={() => this.cancelStep(task)}>Cancel</Menu.Item>
									)}
									{task.step !== 0 && (
										<Menu.Item onClick={() => this.rejectStep(task)}>Reject</Menu.Item>
									)}
								</Menu>
							);

							return (
								<Col span={12} key={i} style={{padding: 10}}>
									<DataCard title={<>{this.getTitle(task)}</>}>
										<Descriptions>
											<Descriptions.Item label={ROP_MIN_LABEL}>{task.min}</Descriptions.Item>
											<Descriptions.Item label={"MAX"}>{task.max}</Descriptions.Item>
										</Descriptions>
										{/*<Row>*/}
										{/*    <Col span={24}>*/}
										{/*        <Dropdown overlay={menu}>*/}
										{/*            <Button style={{float: 'right'}} type={'primary'}>Actions</Button>*/}
										{/*        </Dropdown>*/}
										{/*    </Col>*/}
										{/*</Row>*/}
										<TasksViewer
											onApprove={this.onStepEnd}
											current={[task]}
											userInfo={this.state.user}
											projectId={this.state.projectId}
											itemInfo={{_id: null}}
											userTasks={this.state.tasks}
										/>
									</DataCard>
								</Col>
							);
						})}
					</Row>
				</Spin>
			</>
		);
	}
}
